import { device } from "@utils";
import { Card } from "antd";
import styled from "styled-components";

export const StyledDashboard = styled.section`
  padding: 39px 4px 38px 38px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-column-gap: 30px;
  column-gap: 30px;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  row-gap: 40px;
  max-height: 94vh;
  overflow-y: scroll;
  .middle-layout {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
  }
`;
export const StyledCard = styled(Card)<{ minwidth?: number }>`
  min-width: ${(p) => `${p.minwidth || 340}px`};
  box-shadow: 0px 2px 6px rgba(13, 10, 44, 0.08);
  border-radius: 20px;
  padding,
  h5 {
    margin: 0;
  }
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ant-select {
      min-width: 120px;
    }
    p {
      font-weight: 500;
      font-size: 14px;
      line-height: 19px;
      letter-spacing: 0.02em;
      color: #9291a5;
    }
    h5 {
      font-weight: 500;
      font-size: 14px;
      line-height: 19px;
      letter-spacing: 0.02em;
      color: #1e1b39;
    }
  }
  footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      column-gap: 6px;
    }
    &.client-footer {
      padding: 20px;
      margin-top: 20px;
      display: flex;
      justify-content: end;
      column-gap: 30px;
    }
  }
  .patient-new {
    font-weight: 800;
    font-size: 40px;
    line-height: 55px;

    display: flex;
    align-items: center;
    letter-spacing: 0.02em;

    color: #00aa67;
  }
  .content,
  .client-info {
    display: flex;
    justify-content: center;
    .progress-inner-text {
      color: #615e83;
      font-size: 16px;
    }
    .number {
      font-size: 24px;
      color: #1e1b39;
      &.small {
        font-size: 10px;
      }
    }
    .total-count {
      padding-left: 10px;
    }
  }
  .chart {
    width: 100%;
    height: 250px;
  }
  .client-info {
    display: flex;
    column-gap: 24px;
    justify-content: space-between;
  }
  .clinic-content {
    width: 100%;
    height: 360px;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item {
    margin: 10px 0;
  }
`;
